<template>
  <div class="container-fluid">
    <div class="row tick-row">
      <main id="main" class="site-main main-content">
        <div class="support-banner"> </div>
        
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <h2 class="support-title">
            You can count on our customer-friendly expert team who takes personal pride in giving top-notch confidential service to each and every customer.
          </h2>

          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12">
                    <div class="row">
                      <a href="/support/portal/login"
                        ><div class="ticket-full">
                          <div class="support-tikt-icn">
                            <img src="/static/assets/fonts/icons/envelop.png" />
                          </div>
                          <div class="support-tikt-cont">
                            <h3>Submit Ticket</h3>
                            <p>
                              Use this form to submit a support ticket to our
                              highly trained staff.
                            </p>
                          </div>
                        </div>
                      </a>

                      <a href="/support/portal/track"
                        ><div class="ticket-full">
                          <div class="support-tikt-icn">
                            <img src="/static/assets/fonts/icons/binocular.png" />
                          </div>
                          <div class="support-tikt-cont">
                            <h3>Track Ticket</h3>
                            <p>
                              Use your email address and ticket number to track the status of your ticket.
                            </p>
                          </div>
                        </div>
                      </a>
                      <!-- End ticket -->
                    </div>
                  </div>

                  <div class="col-md-12 ticket-collapse">
                    <div id="accordion">
                      <!-- First item -->
                      <div class="card">
                        <div class="card-header tick-card" id="headingOne" data-toggle="collapse"
                                data-target="#collapseOne">
                          <h5 class="mb-0">
                            <div class="collapse-img">
                              <img
                                src="/static/assets/fonts/icons/newspaper.png"
                                width="70px"
                              />
                            </div>
                            <div class="collapse-items">
                              <h4>Announcements</h4>
                              <button
                                class="btn btn-link"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                              >
                                View the latest news and
                                <span class="br"></span> announcements.
                              </button>
                            </div>
                          </h5>
                        </div>

                        <div id="collapseOne" class="collapse">
                          <div class="card card-body tick-bott">
                            <h3>Welcome to this Support Team</h3>
                            <p>
                              Our services are up and running. If you have any technical issues, please contact support@clearmeout.com.
                            </p>
                            <small
                              ><span class="announ-date"
                                ><b>22 July 2020</b></span
                              >
                              , <span>10.20AM</span></small
                            >
                          </div>
                        </div>
                      </div>
                      <!-- Last item -->
                      <!--  <div class="card">
                                              <div class="card-header tick-card" id="headingOne">
                                                <h5 class="mb-0">
                                                  <div class="collapse-img"><img src="static/assets/fonts/icons/book-solid.svg" width="45px;"></div>
                                                  <div class="collapse-items">
                                                    <a href=""><h4>Announcements</h4></a>
                                                    <button class="btn btn-link" data-toggle="collapse" data-target="#CollapseTwo">
                                                      View the latest news and <span class="br"></span>announcements.                                                 
                                                    </button>
                                                  </div>
                                                </h5>
                                              </div>

                                              <div id="CollapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card card-body tick-bott">
                                                  <h3>Rest API</h3>
                                                  <p>The REST API can be used to access data and perform actions from external applications.</p>

                                                  <h3>Simple Auth</h3>
                                                  <p>SimpleAuth is an automatic authentication method to allow you to log users in from third party code/software. Useful in integrations with other client management software, it will generate a session for the user without them having to do anything or requi</p>

                                                  <h3>New Installation</h3>
                                                  <p>A license with valid support & upgrade coverage is required to download. Once you have a valid license please login to the members area select an active license and download the latest version.</p>

                                                  <a href=""><button type="button">View All >></button></a>
                                                </div>
                                              </div>
                                            </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->

        <div class="support-contact-section">
          <div class="container">
            <div class="row">
              <h2 style="color: #6773dd;text-align: center;">Contact Us</h2>
              <h3 style="color: #6773dd;text-align: center;margin-bottom: 50px;">We’ll respond as soon as possible with a helping hand.</h3>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="hc_icon_element">
                  <span class="icon icon-envelope"></span>
                </div>
                <h3 class="menu_item_title text-center">E-mail</h3>
                <p class="menu_item_content text-center"><b>Service:</b> service@clearmeout.com
                  <br><b>Support:</b> support@clearmeout.com
                  <br><b>Legal:</b> legal@clearmeout.com
                </p>

              </div>
              <div class="col-md-6">
                <div class="hc_icon_element">
                  <span class="icon icon-phone"></span>
                </div>
                <h3 class="menu_item_title text-center">Hotline Numbers</h3>
                <p class="menu_item_content text-center"> + 61 (38) 3720177<b> (int)</b>
                <br> + 61 (38) 5926433 <b></b></p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "support_portal",
  data() {
    return {
      msg: "Clear Me Out - Support",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/support.vue